import axios from 'axios'

export default {
  namespaced: true,

  state: {
    clubs: [],
    tournaments: [],
    membersPage: { data: [], total: 0 }
  },

  getters: {
    clubs: state => state.clubs,
    tournaments: state => state.tournaments,
    membersPage: state => state.membersPage
  },

  actions: {
    async loadTournaments ({ commit }) {
      const response = await axios.get('ranking/tournaments')
      commit('setTournaments', Array.isArray(response.data) ? response.data : [])
      return response.data
    },

    async loadClubs ({ commit }, params = {}) {
      const response = await axios.get('ranking/clubs', { params })
      commit('setClubs', Array.isArray(response.data) ? response.data : [])
      return response.data
    },

    async loadMembers ({ commit }, params = {}) {
      const response = await axios.get('ranking/members', { params })
      const data = response.data || {}
      commit('setMembersPage', { data: data.data || [], total: data.total || 0 })
      return response.data
    },

    async resetPoints () {
      const response = await axios.post('ranking/reset-points')
      return response.data
    }
  },

  mutations: {
    setClubs (state, clubs) {
      state.clubs = clubs
    },
    setTournaments (state, tournaments) {
      state.tournaments = tournaments
    },
    setMembersPage (state, payload) {
      state.membersPage = payload
    }
  }
}
